export default "__VITE_ASSET__D_jRi2KR__"